import { SearchOutlined } from '@ant-design/icons'
import { Button, Input, InputProps } from 'antd'
import { isEmpty } from 'lodash'

import { FilterSearchProps } from './interface'

export const FilterSearch = ({
  prefixCls,
  placeholder,
  selectedKeys,
  clearFilters,
  setSelectedKeys,
  confirm
}: FilterSearchProps) => {
  const onSearchChange: InputProps['onChange'] = e => {
    setSelectedKeys([e.target.value])
  }

  const handleReset = () => {
    clearFilters?.()
  }

  const handleConfirm = () => {
    confirm({ closeDropdown: true })
  }

  return (
    <>
      <div className={`${prefixCls}-dropdown-search`}>
        <Input
          className={`${prefixCls}-dropdown-search-input`}
          placeholder={placeholder}
          prefix={<SearchOutlined />}
          value={selectedKeys[0]}
          onChange={onSearchChange}
        />
      </div>
      <div className={`${prefixCls}-dropdown-btns`}>
        <Button
          disabled={isEmpty(selectedKeys)}
          type='link'
          onClick={handleReset}
        >
          重置
        </Button>
        <Button type='primary' onClick={handleConfirm}>
          确定
        </Button>
      </div>
    </>
  )
}
